import React from 'react';
//import ReactDOM from 'react-dom';
//import { render } from 'react-dom';
import { createRoot } from 'react-dom/client';
import './styles/global-styles.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SocketioProvider } from './contexts/SocketioContext';
import { HomeContext } from './contexts/HomeContext';
import { Home } from './templates/Home';
import { Page404 } from './templates/Page404';
import { Cardapio } from './templates/SelecaoLoja';
import { PageSuccess } from './templates/PageSuccess';
import { PreCadastro } from './templates/PreCadastro';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import ReactGA from 'react-ga';

const TRACKING_ID = 'G-LHGJMGLKCQ';

ReactGA.initialize(TRACKING_ID);

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <HomeContext>
    <SocketioProvider>
      <React.StrictMode>
        <Router>
          <Routes>
            <Route path="/loja/PreCadastro/" element={<PreCadastro />} exact />
            <Route path="/loja/Cardapio/" element={<Cardapio />} exact />
            {/* <Route path="/loja/QrCode/" element={QrCodeReader} exact /> */}
            <Route path="/loja/Page404/:message?" element={<Page404 />} exact />
            <Route path="/loja/PageSuccess/:msg?" element={<PageSuccess />} exact />
            <Route path="/loja/:tipo_app/:loja/:fantasia" element={<Home />} />
            <Route path="/loja/:tipo_app/:loja/" element={<Home />} />
            <Route path="/loja/:loja?" element={<Home />} exact />
            <Route path="/" element={<Home />} exact />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Router>
      </React.StrictMode>
    </SocketioProvider>
  </HomeContext>,
);
